<template>
  <div class="AutoscalingMonitorSearch">
    <Row :gutter="4">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="4">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('alarms.common.pleaseSelectCompany')"
            :transfer="true"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
        <Col span="4">
          <!-- 账户类型 -->
          <Select
            v-model="accountType"
            filterable
            :placeholder="$t('alarms.common.filterByAccountType')"
            :transfer="true"
          >
            <Option value="" selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in accountTypeList"
              :key="item.name"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
        <Col span="4">
          <!--账户名称 -->
          <Input
            v-model="accountName"
            :placeholder="$t('alarms.common.filterByAccountName')"
          />
        </Col>
        <Col span="4">
          <Button
            type="primary"
            v-hasPermission="['monitor:autoscalingMonitor:page']"
            @click="getData"
            >{{ $t("message.select") }}</Button
          >
        </Col>
      </div>
    </Row>
  </div>
</template>
<script>
import TableAutoscaling from "../autoscaling/TableAutoscaling";
import { setCookie, getCookie } from "../../../utils/cookieUtil.js";
var tableAutoscaling = TableAutoscaling;
export default {
  name: "AutoscalingMonitorSearch",
  data() {
    return {
      accountName: "",
      accountType: "",
      company: getCookie(global.companyId),
      companyId: "",
      companyList: [],
      accountTypeList: [
        {
          id: 0,
          name: "AWS"
        },
        {
          id: 1,
          name: "Aliyun"
        },
        {
          id: 2,
          name: "Azure"
        },
        {
          id: 3,
          name: "VMware"
        },
        {
          id: 4,
          name: "GCP"
        }
      ]
    };
  },
  mounted: function() {
    if (this.company == 1) {
      this.getCompanyDropDownBox();
    }
  },
  methods: {
    getData() {
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit("accountType", this.accountType);
      eventBus.$emit("accountName", this.accountName);
      tableAutoscaling.methods.showAll();
    },
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    }
  }
};
</script>
<style scoped>
.AutoscalingMonitorSearch {
  height: 51px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/autoscaling/AutoscalingMonitorSearch.vue